import React, { useEffect } from "react";
import Options from "./options";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { formatPrice } from "../../../utils/constants";
const SelectOptions = ({
  noAll,
  style,
  selectedOption,
  name,
  values,
  onChange,
  placeholder,
  boxStyle,
  disabled,
  namePrefix,
  nameSuffix,
  isPrice,
  loading
}) => {
  const { t, i18n } = useTranslation();
  const lang =
    i18n.language === "English"
      ? "en"
      : i18n.language === "Arabic"
      ? "ar"
      : "ku";
  const skip = ["", "", null, undefined, NaN];

  if (name?.toLowerCase()?.includes("price")) {
    values = values?.map((v) => ({ ...v, name: formatPrice(lang, v.value) }));
  }

  return (
    <select
      className={style}
      name={name}
      onChange={onChange}
      style={boxStyle}
      disabled={disabled || loading}
      data-theme="none"
      data-role="none"
    >
      <Options
        value={t(placeholder)}
        name={t(placeholder) || t("Select")}
        hidden={true}
        disabled={true}
        selected={selectedOption?.length == 0 || skip.includes(selectedOption)}
      ></Options>
      {!noAll && (
        <Options
          value={name === "cities" ? t("National") : t("Any")}
          name={name === "cities" ? t("National") : t("Any")}
          selected={[t("Any"), t("National")].includes(selectedOption)}
        ></Options>
      )}
      {values?.map((item, key) => {
        let value =
          item?.name?.[i18n.language] ||
          item?.name?.[lang] ||
          item.name ||
          item.label ||
          item;
        // let nameValue = t(value)
        // if(namePrefix) {
        //   nameValue = namePrefix.concat(nameValue)
        // }
        // if(nameSuffix) {
        //   nameValue = nameValue.concat(nameSuffix)
        // }

        return (
          <Options
            value={item?.value == 0 ? 0 : item?.value || value}
            name={t(value)}
            selected={[value, item?.value].includes(selectedOption)}
            // disabled={item.disabled && item.disabled ? true : null}
            style={""}
            key={value}
          />
        );
      })}
    </select>
  );
};
export default SelectOptions;
